// 메뉴
export const MENUS = [
	{ id: 'smaMonth01', text: '소개', url: '/sma/month/about' },
	{ id: 'smaMonth02', text: '선정 방식', url: '/sma/month/about' },
	{ id: 'smaMonth03', text: '투표 방법', url: '/sma/month/about' },
	{ id: 'smaMonth04', text: '투표 정책', url: '/sma/month/about' },
	{ id: 'smaMonth05', text: '순위 확인', url: '/sma/month' }
];
